import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { MicroLabel } from './micro-label';

/**
 * Inputs sit on --inset, which is darker than the card behind them. That inversion is
 * deliberate in the mockups: fields read as wells, not as raised surfaces.
 */
export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        'w-full rounded border border-border bg-inset px-3 py-2.5 text-sm text-foreground',
        'placeholder:text-dim focus:border-primary focus:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
}

export function Field({
  label,
  htmlFor,
  children,
  className
}: {
  label: string;
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('grid gap-2', className)}>
      <MicroLabel as="label" {...(htmlFor ? { htmlFor } : {})}>
        {label}
      </MicroLabel>
      {children}
    </div>
  );
}
